<template>
    <!-- 子路由 /zixun/order 激活时全屏渲染预约页（对应 uniapp 的 navigateTo 页面跳转） -->
    <router-view v-if="$route.matched.length > 1"></router-view>
    <div class="zixun-page" v-else>
        <!-- 顶部标题栏（对应 uniapp 原生导航栏「心理咨询预约」#F5F9FE 背景黑字） -->
        <div class="nav-bar">
            <span class="nav-back" @click="goBack">‹</span>
            <span class="nav-title">心理咨询预约</span>
        </div>

        <!-- 顶部banner -->
        <div class="banner">
            <img src="/static/images/zixun-top.png" alt="" />
        </div>

        <!-- 咨询师列表 -->
        <div class="counselor-list">
            <div class="counselor-card" v-for="(item, idx) in counselorList" :key="idx">
                <div class="card-body">
                    <!-- 头像 -->
                    <div class="avatar-wrap">
                        <img class="avatar" :src="item.avatar" alt="" />
                        <span class="status-tag">空闲</span>
                    </div>
                    <!-- 信息 -->
                    <div class="info-area">
                        <div class="name-row">
                            <span class="name">{{ item.name }}</span>
                            <span class="years">从业{{ item.years }}年</span>
                        </div>
                        <div class="title-row">
                            <span class="title-text">{{ item.title }}</span>
                        </div>
                        <div class="intro-row">{{ item.intro }}</div>
                        <div class="domain-row">
                            <span class="domain-tag" v-for="(d, di) in item.domains" :key="di">
                                {{ d }}
                            </span>
                        </div>
                        <div class="method-row">
                            <span class="method-tag" v-for="(m, mi) in item.methods" :key="mi">
                                {{ m }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部banner -->
        <div class="banner">
            <img src="/static/images/zixun-bottom.png" alt="" />
        </div>

        <!-- 底部预约按钮 -->
        <div class="footer-bar">
            <div class="book-btn" @click="handleBook">
                <span class="btn-main">立即咨询</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 咨询师静态数据
            counselorList: [
                {
                    name: '谢艳',
                    years: 1,
                    avatar: '/static/images/counselor-1.jpg',
                    title: '德瑞姆中级咨询师',
                    intro: '从事心理咨询工作一年，对青少年及女性群体心理困扰及自我成长较为擅长',
                    domains: ['情绪困扰', '亲子教育', '婚姻家庭'],
                    methods: ['面询', '语音', '视频', '图文'],
                    city: '无锡市',
                    price: 200,
                },
                {
                    name: '孔江烨',
                    years: 4,
                    avatar: '/static/images/counselor-2.jpg',
                    title: '二级心理咨询师',
                    intro: '儿童青少年情绪问题、人际关系、亲子关系、青春期困惑、家庭治疗、自我探索与成长',
                    domains: ['情绪困扰', '心理健康', '婚姻家庭'],
                    methods: ['面询', '语音', '视频', '图文'],
                    city: '张家港市',
                    price: 500,
                },
                {
                    name: '傅朝霞',
                    years: 5,
                    avatar: '/static/images/counselor-3.jpg',
                    title: '三级心理咨询师',
                    intro: '国家二级心理咨询师、美国NGH催眠师/授证导师、ABNLP专业执行师、企业EAP专业指导师、系统式家庭咨询师、科普委心理科学传播讲师',
                    domains: ['情绪困扰', '心理健康', '亲子教育'],
                    methods: ['面询', '语音', '视频', '图文'],
                    city: '深圳市',
                    price: 700,
                },
            ],
        };
    },
    methods: {
        // 返回上一页（无历史记录时兜底回门户页）
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.replace('/portal');
            }
        },

        // 跳转到预约页面
        handleBook() {
            this.$router.push('/zixun/order');
        },
    },
};
</script>

<style lang="scss" scoped>
/* 顶部标题栏（对应 uniapp 原生导航栏样式） */
.nav-bar {
    position: sticky; // 滚动时固定在顶部
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88rpx;
    background: #f5f9fe;
}

.nav-back {
    position: absolute;
    left: 24rpx;
    font-size: 48rpx;
    color: #000;
    line-height: 1;
    padding: 0 16rpx;
    cursor: pointer;
}

.nav-title {
    font-size: 32rpx;
    font-weight: 500;
    color: #000;
}

.zixun-page {
    min-height: 100vh;
    background: linear-gradient(180deg, #f5f9fe 17%, #ffffff 100%);
    padding-bottom: 180rpx;
}

/* banner图 */
.banner {
    width: 100%;
    img {
        width: 100%;
        height: auto;
        display: block;
    }
}

/* 咨询师列表 */
.counselor-list {
    padding: 20rpx 30rpx;
    background: #eef3f7;
}

.counselor-card {
    background: #fff;
    border-radius: 16rpx;
    border: 2rpx solid #cfdaef;
    box-shadow: 0rpx 12rpx 16rpx 0rpx rgba(0, 0, 0, 0.09);
    padding: 30rpx;
    margin-bottom: 24rpx;

    &:last-child {
        margin-bottom: 0;
    }
}

.card-body {
    display: flex;
    align-items: flex-start;
}

/* 头像 */
.avatar-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 28rpx;
    flex-shrink: 0;
}

// 头像（aspectFill 对应 object-fit:cover）
.avatar {
    width: 140rpx;
    height: 140rpx;
    border-radius: 80rpx;
    border: 4rpx solid rgba(241, 233, 210, 0.28);
    object-fit: cover;
}

.status-tag {
    margin-top: 16rpx;
    font-size: 22rpx;
    color: #445895;
    text-align: center;
}

/* 信息区域 */
.info-area {
    flex: 1;
    min-width: 0;
}

.name-row {
    display: flex;
    align-items: center;
    margin-bottom: 10rpx;
}

.name {
    font-size: 30rpx;
    font-weight: 600;
    color: #000;
}

.years {
    font-size: 20rpx;
    color: #333;
    margin-left: 14rpx;
}

.title-row {
    margin-bottom: 10rpx;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.title-text {
    font-size: 22rpx;
    color: #5a5a5a;
}

.intro-row {
    font-size: 22rpx;
    color: #5a5a5a;
    line-height: 30rpx;
    margin-bottom: 12rpx;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.domain-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12rpx;
}

.domain-tag {
    font-size: 20rpx;
    color: #445895;
    padding: 4rpx 10rpx;
    background: #eceff8;
    margin-right: 8rpx;
    margin-bottom: 6rpx;
    border-radius: 4rpx;
}

.method-row {
    display: flex;
}

.method-tag {
    width: 60rpx;
    height: 32rpx;
    border: 1rpx solid #e6a525;
    font-size: 20rpx;
    color: #e6a525;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10rpx;
    border-radius: 4rpx;
}

/* 底部预约按钮 */
.footer-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 16rpx 30rpx;
    padding-bottom: calc(16rpx + env(safe-area-inset-bottom));
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.book-btn {
    width: 90%;
    min-height: 100rpx;
    background: #363940;
    border-radius: 12rpx;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;

    &:active {
        opacity: 0.85;
    }
}

.btn-main {
    font-size: 30rpx;
    font-weight: 600;
    color: #dfcead;
}
</style>
